module.exports = __webpack_public_path__ + "img/etc-etc-checkbox-sq.e98c7773.svg";